"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFuturesSymbolTradeInfoParseContext = exports.useFuturesSymbolTradeInfoContext = exports.FuturesSymbolTradeInfoContext = void 0;
const react_1 = require("react");
const component_1 = require("../../component");
exports.FuturesSymbolTradeInfoContext = (0, react_1.createContext)({});
const useFuturesSymbolTradeInfoContext = () => {
    return (0, react_1.useContext)(exports.FuturesSymbolTradeInfoContext);
};
exports.useFuturesSymbolTradeInfoContext = useFuturesSymbolTradeInfoContext;
function useFuturesSymbolTradeInfoParseContext(params, active) {
    var _a;
    const curInfo = (_a = (0, exports.useFuturesSymbolTradeInfoContext)()) === null || _a === void 0 ? void 0 : _a.symbolTradeInfo;
    const alreadyHad = !!curInfo && curInfo.symbol === params.symbol;
    const symbolTradeInfo = (0, component_1.useFuturesSymbolTradeInfo)(params, active);
    return alreadyHad ? curInfo : symbolTradeInfo;
}
exports.useFuturesSymbolTradeInfoParseContext = useFuturesSymbolTradeInfoParseContext;
